<template>
	<div class="industrialparkDetail " v-title :data-title="pageinfo.parkName">
		<leftnav class="fl"></leftnav>
		<div class="index_left" :style="isCollapse?'margin-left: 0;width:100%':''">
			<govheader></govheader>
			<div class="index_left_centerpage">
				<div class="introduction_park whitebox">
					<div class="introduction_park_top">
						<!-- <div class="industrialpark_focus">关注</div> -->
						<span :class="pageinfo.collectId == 0 ? 'collectbtn add fr' : 'collectbtn remove fr'"
							@click="collectFun()">{{ pageinfo.collectId == 0 ? '+添加关注' : '取消关注' }}</span>
						<h3 class="introduction_park_name">{{ pageinfo.parkName }}</h3>
						<!-- <p class="introduction_park_detail">恒信东方文化创意产业园位于北京市东城区，北京市东城区藏经馆胡同2号圣唐古驿文化创意园，　本数据来自前瞻产业研究院产业园区数据库，前瞻产业研究院20年持续聚焦全国细分产业研究、产业规划、产业园区规划、产业地产规划、特色小镇规划、产业新城规划及产业园区招商引资等，助力地方产业发展，促进产城融合。</p> -->
						<p class="introduction_park_detail">{{ pageinfo.summary }}</p>
					</div>
					<div class="introduction_park_map">
						<!-- 	<baidu-map :center="center1" @ready="handler" :zoom="zoom" @click="getClickInfo"
							:scroll-wheel-zoom='true' style="height:460px">
							<bml-marker-clusterer :averageCenter="false">
								<bm-marker :position="center1"></bm-marker>
							</bml-marker-clusterer>
						</baidu-map> -->
						<baidu-map style="width: 100%; height:460px;" :zoom="zoom" @ready="handler"
							:scroll-wheel-zoom='true' id="dituContent">
							<bm-view style="width: 100%; height:460px; flex: 1"></bm-view>
							<bm-local-search :keyword="addressKeyword" :auto-viewport="true" style="display: none">
							</bm-local-search>
							<bm-geolocation anchor="BMAP_ANCHOR_BOTTOM_RIGHT" :showAddressBar="true"
								:autoLocation="true"></bm-geolocation>
						</baidu-map>
					</div>
				</div>
				<div class="whitebox right_topbox">
					<div class="right_boxtitle">
						<span class="fl right_title">园区内注册企业</span>
					</div>
					<table border="0" cellspacing="0" cellpadding="0">
						<tr>
							<td>公司名称</td>
							<td>
								<input type="text" placeholder="请输入公司名称" class="ind_company_name" v-model="companyname" />
								<span class="ind_title">注册资本</span>
								<input type="text" placeholder="不限" class="typetext" v-model="mincapital" /><span
									class="aaa">~</span>
								<input type="text" placeholder="不限" class="typetext" v-model="maxcapital" /><span
									class="aaa">万元</span>
								<span class="ind_title">成立时间</span>
								<el-date-picker v-model="mindate" type="date" placeholder="选择日期"> </el-date-picker>
								<span class="aaa">至</span>
								<el-date-picker v-model="maxdate" type="date" placeholder="选择日期"></el-date-picker>
							</td>

							<!-- 		<tr>
								<td>经营范围</td>
								<td> 
										<el-select v-model="value" placeholder="请选择经营范围"> 
										    <el-option
										      v-for="item in options"
										      :key="item.value"
										      :label="item.label"
										      :value="item.value">
										    </el-option>
										  </el-select> 
												<span class="addcondition">+添加条件</span>
								</td> 
						</tr> -->
						</tr>
						<tr>
							<td></td>
							<td>
								<p><span class="gov_screen" @click="getpagedata()">筛选</span><!-- 已选择&nbsp;2&nbsp;个条件 -->
								</p>
							</td>
						</tr>
					</table>
				</div>
				<div class="enterprise_list_box  whitebox">
					<div class="enterparise_guide oh" style="width: 95%; ">
						<p class="fl">{{ pageinfo.parkName }}<span class="searchnum orangefont">{{ total }}</span>家企业
						</p>
					</div>
					<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table" v-show="parkdata.length > 0">
						<tr>
							<th class="xuhaotd">序号</th>
							<th class=" ">企业名称</th>
							<th>注册资本</th>
							<th>所属行业</th>
							<th>所属城市</th>
							<th>详细地址</th>
						</tr>
						<tr v-for="(item, i) in parkdata" :key="i">
							<td>{{ 20 * (page - 1) + i + 1 }}</td>
							<td class="title" @click="routerlinkid('/enterprises', item.stockCode)">
								{{ item.title }}</td>
							<td>{{ item.regCapital == '' ? '-' : item.regCapital }}</td>
							<td>{{ item.industry == '' ? '-' : item.industry }}</td>
							<td>{{ item.city == '' ? '-' : item.city }}</td>
							<td>{{ item.address }}</td>
						</tr>
					</table>
					<div class="centerpage1 company_pagelist" v-show="totalPage > 1">
						<zpagenav v-bind:page="page" v-bind:page-size="pageSize" v-bind:total="total"
							v-bind:max-page="maxPage" v-on:pagehandler="pageHandler">
						</zpagenav>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import drugMarkerIcon from '../../assets/img/dw.png' // 以import的方式导入图片文件
import { mapState, mapMutations, mapGetters } from "vuex";

export default {
	name: 'usermenu',
	computed: {
		...mapState({
			isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
	},
	data() {
		return {
			userdata: {
				userType: 0,
			},
			// center1: {
			// 	lng: 116.426736,
			// 	lat: 39.954027
			// },
			zoom: 15,
			options: [{
				value: '选项1',
				label: '黄金糕'
			}, {
				value: '选项2',
				label: '双皮奶'
			}, {
				value: '选项3',
				label: '蚵仔煎'
			}, {
				value: '选项4',
				label: '龙须面'
			}, {
				value: '选项5',
				label: '北京烤鸭'
			}],
			value: '',
			value1: '',
			parkdata: [],
			id: 0,
			pageinfo: [], //页面基本信息 
			companyname: '',
			mincapital: '',
			maxcapital: '',
			maxdate: '',
			mindate: '',
			page: 1, //显示的是哪一页
			haspage: true, //是否还有下一页
			pageSize: 10, //每一页显示的数据条数
			total: 0, //记录总数
			totalPage: 1,
			maxPage: 10, //最大页数
			center: { lng: 116.403678, lat: 39.914452 },
			zoom: 13,
			showMaps: true,
			addressKeyword: '',
			adressName: "",
			mapIsReady: false,
			isShowIcon: false,
		}
	},
	// watch: {//深度 watcher 
	//   'center1': {
	//     handler (val, oldVal) { 
	// 					 console.log('111',val,oldVal);
	// 						this.handler(window.BMap);
	//     },
	//     // deep: true
	//   }
	// },
	created() {
		this.$nextTick(() => {
			// 禁用右键
			document.oncontextmenu = new Function("event.returnValue=false");
			// 禁用选择
			document.onselectstart = new Function("event.returnValue=false");
		});
		this.id = this.$route.query.id;
		this.userdata = this.getuserinformain();

	},
	mounted() {

		this.bus.$emit('loading', true);
		if (this.userdata.edition < 1) {
			var _this = this;
			alert('升级版本后即可查看本页面,自动跳转');
			setTimeout(function () {
				_this.routerself('/totalEnterprises');
			}, 1000)
			return;
		}
		this.getpagedata();

	},
	methods: {
		handler({ BMap, map }) {
			console.log('map ready');
			// 初始化地图,设置中心点坐标
			this.mapIsReady = true;
			this.map = map;
			//this.setMapPointer();
			// var point = new BMap.Point(117.39, 115.25)
			// var point = new BMap.Point(this.center.lng, this.center.lat)
			// map.centerAndZoom(point, 13)

			// 添加鼠标滚动缩放
			map.enableScrollWheelZoom();
			// 添加缩略图控件
			map.addControl(new BMap.OverviewMapControl({ isOpen: false, anchor: BMAP_ANCHOR_BOTTOM_RIGHT }));
			// 添加缩放平移控件
			// map.addControl(new BMap.NavigationControl());
			//添加比例尺控件
			// map.addControl(new BMap.ScaleControl());
			//添加地图类型控件
			// map.addControl(new BMap.MapTypeControl());
			if (this.isShowIcon) {
				this.setMapPointer();
			}
		},
		getClickInfo(e) {
			this.center.lng = e.point.lng
			this.center.lat = e.point.lat
			/* 利用坐标获取地址的详细信息 */
			let geoCoder = new BMap.Geocoder();
			geoCoder.getLocation(e.point, res => {
				console.log(res);
				this.adressName = res.address
			})
			this.map.clearOverlays();
			var icon = new BMap.Icon(drugMarkerIcon, new BMap.Size(20, 20));
			var pointer = new BMap.Point(e.point.lng, e.point.lat)
			var marker = new BMap.Marker(pointer);
			this.map.addOverlay(marker);
			var circle = new BMap.Circle(pointer, 500);
			circle.setFillColor("blue"); //填充颜色
			circle.setStrokeWeight(1);// 设置圆形边线的宽度，取值为大于等于1的整数。
			circle.setFillOpacity(0.3);// 返回圆形的填充透明度。
			circle.setStrokeOpacity(0.3);// 设置圆形的边线透明度，取值范围0 - 1。 
			this.map.addOverlay(circle);// 把圆添加到地图中
			// 以定位点为中心自定义画圆
		},
		setMapPointer() {
			if (!this.mapIsReady) {
				this.isShowIcon = true;
				return;
			}
			this.isShowIcon = false;
			this.map.clearOverlays();
			var icon = new BMap.Icon(drugMarkerIcon, new BMap.Size(20, 20));
			var pointer = new BMap.Point(this.center.lng, this.center.lat)
			var marker = new BMap.Marker(pointer, { strokeColor: 'Red', strokeWeight: 6, strokeOpacity: 1, Color: 'Red', fillColor: '#f03' });
			// var marker = new BMap.Marker(pointer, { icon: icon }); //使用图片
			this.map.addOverlay(marker);
			this.map.panTo(pointer); //转到该点位置
			this.map.centerAndZoom(pointer, 15);
			var circle = new BMap.Circle(pointer, 500);
			circle.setFillColor("blue"); //填充颜色
			circle.setStrokeWeight(1);// 设置圆形边线的宽度，取值为大于等于1的整数。
			circle.setFillOpacity(0.3);// 返回圆形的填充透明度。
			circle.setStrokeOpacity(0.3);// 设置圆形的边线透明度，取值范围0 - 1。 
			this.map.addOverlay(circle);// 把圆添加到地图中
		},
		showMap() {
			this.center.lat = this.infact_center.lat;
			this.center.lng = this.infact_center.lng;
			this.showMaps = true;
			this.modalVisible = false;
			setTimeout(() => {
				this.setMapPointer();
			}, 800)
		},

		//格式化日期 （时间戳）
		dateFormat(date) {
			var M = date.getMonth() + 1;
			M = M < 10 ? ('0' + M) : M;
			var y = date.getFullYear();
			var d = date.getDate();
			d = d < 10 ? ('0' + d) : d;
			var h = date.getHours() >= 10 ? date.getHours() : '0' + date.getHours();
			var m = date.getMinutes() >= 10 ? date.getMinutes() : '0' + date.getMinutes();
			var s = date.getSeconds() >= 10 ? date.getSeconds() : '0' + date.getSeconds();
			var time = y + '-' + M + '-' + d;
			var stime = y + '-' + M + '-' + d + ' ' + h + ':' + m + ':' + s;
			console.log('time', time);
			// if (type == "todo") {
			// 	this.addtodoTime = stime;
			// }
			// if (type == 'notify') {
			// 	this.notifyTime = stime;
			// }
			return time;
		},


		getpagedata(pages) {
			var _this = this;
			var ajpage = 1;
			if (pages) {
				ajpage = pages;
			}
			this.page = ajpage;
			_this.bus.$emit('loading', true);
			console.log(this.mindate, this.maxdate);
			var dmindate = "", dmaxdate = "";
			if (this.mindate !== '' && this.mindate !== null) {
				dmindate = '&minDate=' + this.dateFormat(this.mindate);
			}
			if (this.maxdate !== '' && this.maxdate !== null) {
				dmaxdate = '&maxDate=' + this.dateFormat(this.maxdate);
			}
			var ajaxurl = this.$api.cyl.park.detail() + "?id=" + this.id + "&kw=" + this.companyname + '&minCapital=' + this.mincapital + '&maxCapital=' + this.maxcapital + dmindate + dmaxdate + '&page=' + ajpage;
			console.log(ajaxurl)
			this.$axios.get(ajaxurl, {
				headers: {
					AuthToken: this.userdata.token
				}
			}).then(function (res) {
				console.log("园区详情", res);
				if (res.data.success) {
					console.log(ajaxurl);
					_this.pageinfo = res.data.data;
					_this.parkdata = res.data.list;
					if (res.data.data.lng != 0 && res.data.data.lat != 0) {
						_this.center = {
							lng: res.data.data.lng,
							lat: res.data.data.lat
						};
						console.log('坐标', _this.center);
						_this.setMapPointer();
					}

					document.title = res.data.data.parkName;
					_this.bus.$emit('loading', false);
					_this.totalPage = res.data.totalPage;
					_this.pageSize = res.data.pageSize;
					_this.total = res.data.totalRecord;
					_this.haspage = res.data.list.length == res.data.pageSize;
				} else {

				}
			}).catch(function (error) {
				console.log('请求失败处理', error);
			});
		},

		//添加删除收藏 
		collectFun() {
			// console.log(this.companyinfor.collectId,this.companyinfor);
			this.listToggleCollect(this.pageinfo, 'acoc');
		},
		pageHandler: function (page) {
			this.page = page;
			this.getpagedata(page);
		},
		// handler({BMap,map}) {
		// 	var _this = this;
		// 	var point = new BMap.Point(_this.center1.lng, _this.center1.lat);
		// 	map.centerAndZoom(point, 100);
		// 	// var marker = new BMap.Marker(point); // 创建标注
		// 	// map.addOverlay(marker); // 将标注添加到地图中
		// 	var circle = new BMap.Circle(point, 6, {
		// 		strokeColor: 'Red',
		// 		strokeWeight: 6,
		// 		strokeOpacity: 1,
		// 		Color: 'Red',
		// 		fillColor: '#f03'
		// 	});
		// 	map.addOverlay(circle);
		// },
		// getClickInfo(e) {
		// 	console.log(e.point.lng)
		// 	console.log(e.point.lat)
		// 	// this.center1.lng = e.point.lng
		// 	// this.center1.lat = e.point.lat
		// },
	},
}
</script>

<style>
/* 去除百度地图版权那行字 和 百度logo */
.anchorBL {
	display: none !important;
}
</style>